import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export async function serviceSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.services}/list-partner-config?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in serviceSearch:', error)
    throw error
  }
}

export async function serviceDetail(id) {
  try {
    const params = new URLSearchParams({ id }).toString()
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.services}/detail-partner-config?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in serviceDetail:', error)
    throw error
  }
}

export async function serviceAdd(body) {
  const response = await apiCMSWithToken.post(
    `${F18_SERVICES.services}/create-partner-config`,
    body
  )
  return response
}

export async function serviceUpdate(body, id) {
  const response = await apiCMSWithToken.post(
    `${F18_SERVICES.services}/update-partner-config`,
    { id, ...body }
  )
  return response
}

export async function serviceDelete(id) {
  const params = new URLSearchParams({ id }).toString()
  const response = await apiCMSWithToken.delete(
    `${F18_SERVICES.services}/delete-partner-config?${params}`
  )
  return response
}
